import React, { useContext, useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { JsonContext } from "../../../../context/JsonContextData";
import ArrowLeft from "../../../../svg/ArrowLeft";
import ArrowRight from "../../../../svg/ArrowRight";
import { containerWidth } from "../../../../utils/measuresForResponsiveness";
import Modal from "../../Modal";
import { Switch } from "../../Switch";
import {
  Button,
  InfoInputs,
  RequiredMessage,
  TitleModal,
  WrapperButton,
  WrapperCheckbox,
} from "./styled";

interface InitialModalProps {
  isOpen: boolean;
  numberInputs: number;
  onSend: () => void;
  onClose: () => void;
}

const InitialModal: React.FC<InitialModalProps> = ({
  isOpen,
  onSend,
  onClose,
  numberInputs,
}) => {
  const [areFirstTwoCheckboxesChecked, setAreFirstTwoCheckboxesChecked] =
    useState(false);
  const [showError, setShowError] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    terms_use: false,
  });

  const url = process.env.REACT_APP_ASSINANDO;

  const { setJsonData } = useContext(JsonContext);

  useEffect(() => {
    setAreFirstTwoCheckboxesChecked(checkboxes.terms_use);
  }, [checkboxes]);

  const handleToggleChange = (name: string, isChecked: boolean) => {
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: isChecked,
    }));
  };

  const handleConfirm = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "ConcordarModal",
        userProject: "Assinando",
        page: "sign",
      },
    });
    if (!areFirstTwoCheckboxesChecked) {
      setShowError(true);
      return;
    }
    setJsonData(checkboxes);
    onSend();
  };

  return (
    <Modal isOpen={isOpen}>
      <TitleModal>Uso de Assinatura Eletrônica</TitleModal>

      <WrapperCheckbox>
        <p>
          Para assinar, é necessário concordar com o uso da assinatura
          eletrônica neste documento e estar ciente do Termo de Consentimento
        </p>

        {/* <div>
          <Switch
            checkboxName="electronic_signature"
            checked={checkboxes.electronic_signature}
            onChange={handleToggleChange}
            text="Concordo em usar assinatura eletrônica*"
          />
          {showError && !checkboxes.electronic_signature ? (
            <RequiredMessage>Este campo é obrigatório.</RequiredMessage>
          ) : null}
        </div> */}
        <div style={{ marginTop: "20px" }}>
          <Switch
            checkboxName="terms_use"
            checked={checkboxes.terms_use}
            onChange={handleToggleChange}
            text={`Eu concordo com os <a href=${url}/termos-de-uso target="_blank">Termos de Consentimento</a>*`}
          />
          {showError && !checkboxes.terms_use ? (
            <RequiredMessage>Este campo é obrigatório.</RequiredMessage>
          ) : null}
        </div>
        {/* <div>
          <Switch
            checkboxName="receive_email"
            checked={checkboxes.receive_email}
            onChange={handleToggleChange}
            text="Quero receber uma cópia do documento via email"
          />
        </div> */}
        {numberInputs > 0 && (
          <div>
            {containerWidth < 768 ? (
              numberInputs === 1 ? (
                <InfoInputs>
                  Clique e preencha o campo que está em vermelho!
                </InfoInputs>
              ) : (
                <InfoInputs>
                  Clique e preencha os{" "}
                  <span style={{ fontWeight: "bold" }}>{numberInputs}</span>{" "}
                  campos que estão em vermelho!
                </InfoInputs>
              )
            ) : numberInputs === 1 ? (
              <InfoInputs style={{ marginTop: "20px" }}>
                Após concordar, é necessário preencher{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    marginBottom: "10px",
                    marginTop: "10px",
                  }}
                >
                  {numberInputs}
                </span>{" "}
                campo para poder completar a assinatura!
              </InfoInputs>
            ) : (
              <InfoInputs style={{ marginTop: "20px" }}>
                Após concordar, é necessário preencher os{" "}
                <span
                  style={{
                    fontWeight: "bold",
                    marginBottom: "10px",
                    marginTop: "10px",
                  }}
                >
                  {numberInputs}
                </span>{" "}
                campos para poder completar a assinatura!
              </InfoInputs>
            )}
          </div>
        )}
      </WrapperCheckbox>
      <WrapperButton>
        <Button
          type="submit"
          backgroundColor="#355B94"
          hoverBackgroundColor="#32568c"
          onClick={onClose}
        >
          <ArrowLeft />
          Voltar
        </Button>
        <Button
          type="submit"
          backgroundColor="#77EC84"
          hoverBackgroundColor="#72E27F"
          color="#2c2c2c"
          onClick={handleConfirm}
        >
          Confirmar
          <ArrowRight fill="#2c2c2c" />
        </Button>
      </WrapperButton>
    </Modal>
  );
};

export default InitialModal;
